import React, { useState } from "react";
import BulkCsvModal from "./BulkCsvModal";
import { SYSTEM_FIELDS } from "./constants";
import { isMappingMissingRequiredFields } from "./csvUtils";

const StatusPill = (props = {}) => {
  const { mapped = false } = props || {};
  return (
    <span
      className={`bulkCsvStatusPill ${mapped ? "pillMapped" : "pillReview"}`}
    >
      {mapped ? "Mapped" : "Review"}
    </span>
  );
};

const StepMapColumns = (props = {}) => {
  const {
    onClose = () => {},
    onBack = () => {},
    onNext = () => {},
    initialMapping = []
  } = props || {};
  const [mapping, setMapping] = useState(initialMapping);

  const updateFieldKey = (colIndex, fieldKey) => {
    const next = [...mapping];
    next[colIndex] = { ...next[colIndex], fieldKey, autoMapped: false };
    setMapping(next);
  };

  const missingRequired = isMappingMissingRequiredFields(mapping);

  return (
    <BulkCsvModal
      title="Map columns"
      subtitle={`${mapping.length} columns detected — confirm the mapping below`}
      onClose={onClose}
      footer={
        <>
          <button
            type="button"
            id="bulkCsvMapBack"
            className="bulkCsvBtnGhost"
            onClick={onBack}
          >
            Back
          </button>
          <button
            type="button"
            id="bulkCsvMapContinue"
            className="bulkCsvBtnPrimary"
            disabled={missingRequired}
            onClick={() => onNext(mapping)}
          >
            Continue
          </button>
        </>
      }
    >
      {missingRequired && (
        <div className="bulkCsvErrorBox">
          <span className="errorText">
            Email, SMTP Host, SMTP Port, IMAP Host and IMAP Port must all be
            mapped to continue.
          </span>
        </div>
      )}
      <div className="bulkCsvTableWrapper">
        <table>
          <thead>
            <tr>
              <th style={{ width: "28%" }}>CSV column</th>
              <th style={{ width: "44%" }}>Maps to</th>
              <th style={{ width: "28%" }}>Status</th>
            </tr>
          </thead>
          <tbody>
            {mapping.map((col, index) => (
              <tr key={`${col.rawHeader}-${index}`}>
                <td>
                  <span className="rawHeaderTag">{col.rawHeader}</span>
                </td>
                <td>
                  <select
                    className="fieldMapSelect"
                    id={`bulkCsvMapSelect-${index}`}
                    value={col.fieldKey}
                    onChange={event =>
                      updateFieldKey(index, event.target.value)
                    }
                  >
                    {SYSTEM_FIELDS.map(field => (
                      <option key={field.key} value={field.key}>
                        {field.label}
                      </option>
                    ))}
                  </select>
                </td>
                <td>
                  <StatusPill mapped={col.fieldKey !== "ignore"} />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </BulkCsvModal>
  );
};

export default StepMapColumns;
export { StepMapColumns };
